import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '../../shared';


/*
   This page has angular.js components in between serverside rendered html.
   We are not wrapping each one in an Angular UpgradeComponent because it would
   be cumbersome and give us no benefit. They are small and independent enough
   to instead be rewritten directly into Angular components, and then added
   to the below module.

   Contrary to the hybrid pages with single entrypoints, this module does
   not get lazily-loaded. We instead import it into the RootAppModule.

   c.f. account-configuration.app.module, cloud-configuration.app.module, user-configuration.app.module
*/

const siteConfigurationComponents = [];

@NgModule({
   declarations: siteConfigurationComponents,
   imports: [
      CommonModule,
      ReactiveFormsModule,
      SharedModule,
   ],
   providers: [],
   exports: siteConfigurationComponents,
})
export class SiteConfigurationAppModule {}

export const SiteConfigurationAjsModule = angular.module('hybd.site.configuration', []);
